export const BASE_API_URL = 'https://api-ca-azure.ammindfulness.com';
export const BASE_CDN_URL =
  'https://meditationcontent.blob.core.windows.net/meditationcontent/estore/v2';
